import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filename"
})
export class FileNamePipe implements PipeTransform {
    transform(url: string): string {
        if (!url) {
            return "Não informado";
        }

        return url.split("?")[0].split("/")[url.split("?")[0].split("/").length - 1];
    }
}
